
import React, { Component } from "react";
import Config from "../../../config";
import { tsDateToThaiDate } from "../../../utils/func";
import { Modal, Button, Select, Radio, Col, Input, notification } from "antd";
import Datetimepicker from "../../jquery/datetimepicker";
import moment from "moment";
import QRCode from 'qrcode.react';
import { connect } from "react-redux";
const RadioGroup = Radio.Group;
const Option = Select.Option;
const InputGroup = Input.Group;

class Xpage6ef04dc17 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latitude: "",
      longitude: "",
      qr: "",
      visible5SubmitPass: false,
      AUDIT: "",
      AUDIT_ID: "",
      _A: [],
      AUDIT_ID_Q: "",
      modeLayout1: false,
      modeLayout2: false,
      modeLayout3: false,
      modeLayout4: false,
      modeLayout5: false,
      visible5Submit: false,
      modeLayout5Type: "",
      data1: {},
      data2: {},
      data3: [],
      data4: {},
      visible2: false,
      visible3: false,
      visible4: false,
      INTERVIEWER_ID: [],
      m3: [],
      m4: {}
    };
    let { year, plt_bld_id } = this.props;

    this.getDataLayoutAll(year, plt_bld_id);
  }

  getDataLayoutAll(year, plt_bld_id) {
    this.getDataLayout1(year, plt_bld_id);
    this.getDataLayout2(year, plt_bld_id);
    // this.getDataLayout3(year, plt_bld_id);
    this.getDataLayout3auto(year, plt_bld_id);
    this.getDataLayout4(year, plt_bld_id);
  }
  openNotificationWithIcon(type, message = "", description = "") {
    notification[type]({ message: message, description: description });
  }
  getMyLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.watchPosition((position)=> {
            console.log("position", position);
            this.setState({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
            });
        }, function(err) {
           console.log("getCurrentPosition:err", err);
           });

         navigator.geolocation.getCurrentPosition(function(position) {
             var pos = { 
                 lat: position.coords.latitude, 
                 lng: position.coords.longitude 
                };
            console.log(pos);
     
           }, function(err) {
           console.log("getCurrentPosition:err", err);
           });
       } else {
                   console.log("getCurrentPosition:err");
       }

    // const location = window.navigator && window.navigator.geolocation;
    // console.log("location", location);
    // if (location) {
    //   location.getCurrentPosition(
    //     position => {
    //         console.log("location", position);
    //       this.setState({
    //         latitude: position.coords.latitude,
    //         longitude: position.coords.longitude
    //       });
    //     },
    //     error => {
    //       this.setState({
    //         latitude: "",
    //         longitude: ""
    //       });
    //     }
    //   );
    // }
  }
  componentDidMount() {
    this.getMyLocation();
  }

  getDataLayout1(year, plt_bld_id) {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc07-l1?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data && data.data.length > 0) {
            this.setState({ modeLayout1: "view", data1: data.data[0] });
          }
          console.log("getData1", data);
        },
        err => {
          console.log("getData1", err);
        }
      );
  }

  getDataLayout2(year, plt_bld_id) {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc17-l2?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data && data.data.length > 0) {
            this.setState({ modeLayout2: "view", data2: data.data[0] });
          }
          console.log("getData2", data);
        },
        err => {
          console.log("getData2", err);
        }
      );
  }

  getDataLayout3auto(year, plt_bld_id) {
    let { time } = this.props
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
      `/api/getReport-ef04dc17-l3-auto?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}&time=${time}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(data => {
          this.getDataLayout3(year, plt_bld_id);
        }, err => {
          this.getDataLayout3(year, plt_bld_id);
          console.log("getData3", err);
        });
  }

  getDataLayout3(year, plt_bld_id) {
    let { time } = this.props
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc17-l3?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data) {
            this.setState({ modeLayout3: "view", data3: data.data ? data.data:[] });
          }
          console.log("getData3", data);
        },
        err => {
          console.log("getData3", err);
        }
      );
  }

  getDataLayout4(year, plt_bld_id) {
    let token = localStorage.getItem("ef_token");
    return fetch(
      Config.api +
        `/api/getReport-ef04dc17-l4?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`,
      {
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data && data.data.length > 0) {
            this.setState({ modeLayout4: "view", data4: data.data[0] });
          }
          console.log("getData4", data);
        },
        err => {
          console.log("getData4", err);
        }
      );
  }

  getINTERVIEWER_ID() {
    let token = localStorage.getItem("ef_token");
    return fetch(Config.api + `/api/getINTERVIEWER_ID?token=${token}`, {
      headers: { "Content-Type": "application/json" }
    })
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000 && data.data && data.data.length > 0) {
            this.setState({ INTERVIEWER_ID: data.data });
          }
          console.log("getINTERVIEWER_ID", data);
        },
        err => {
          console.log("getINTERVIEWER_ID", err);
        }
      );
  }

  putDataLayout3() {
    let { step, plt_bld_id, year, time } = this.props;
    let token = localStorage.getItem("ef_token");
    let { m3 } = this.state;
    let data = { data: m3, token, step, plt_bld_id, year, time };
    console.log("data", data);
    return fetch(Config.api + `/api/putReport-ef04dc17-l3`, {
      method: "PUT", // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(
        data => {
          console.log(data.resultCode);
          if (data.resultCode == 20000) {
            let { year, plt_bld_id } = this.props;

            this.setState({ visible3: false, m3: [] });
            this.getDataLayout3(year, plt_bld_id);
          } else {
            alert("error");
          }
        },
        () => {
          alert("error");
        }
      );
  }

  putDataLayout4() {
    let { step, plt_bld_id, year, time } = this.props;
    let token = localStorage.getItem("ef_token");
    let { m4 } = this.state;
    let data = { data: m4, token, step, plt_bld_id, year, time };
    console.log("data", data);
    return fetch(Config.api + `/api/putReport-ef04dc17-l4`, {
      method: "PUT", // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(
        data => {
          // console.log(data.resultCode)
          if (data.resultCode == 20000) {
            let { year, plt_bld_id } = this.props;

            this.setState({ visible4: false, m4: {} });
            this.getDataLayout4(year, plt_bld_id);
          } else {
            alert("error");
          }
        },
        () => {
          alert("error");
        }
      );
  }

  putDataLayout5(image) {
    let { step, plt_bld_id, year, time } = this.props;
    let token = localStorage.getItem("ef_token");

    let data = { image: image, token, step, plt_bld_id, year, time };
    console.log("data", data);
    return fetch(Config.api + `/api/putReport-ef04dc17-l5`, {
      method: "PUT", // or 'PUT'
      body: JSON.stringify(data), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(response => response.json())
      .then(
        data => {
          if (data.resultCode == 20000) {

          } else {
            this.openNotificationWithIcon(
              "error",
              "Error",
              "ไม่สารถลงชื่อได้"
            );
            this.setState({
              visible5: false,
              visible5Submit: false
            });
          }
        },
        () => {
          this.openNotificationWithIcon(
            "error",
            "Error",
            "ไม่สารถลงชื่อได้"
          );
          this.setState({
            visible5: false,
            visible5Submit: false
          });
        }
      );
  }

  Layout1() {
    let { data1, data2 } = this.state;
    return (
      <div>
        <h1>
          แบบกำหนดความรับผิดชอบในการตรวจสอบและรับรองการจัดการพลังงานตามข้อกำหนดวิธีการจดการพลังงานประจำปี{" "}
          {this.props.year}
        </h1>
        <table style={{ borderSpacing: "1px 1px" }}>
          <tbody>
            <tr>
              <th style={{ width: "20%" }}>ชื่อโรงงานควบคุม</th>
              <td style={{ width: "80%" }}>{data1.PLT_BLD_NAME}</td>
            </tr>
            <tr>
              <th style={{ width: "20%" }}>รหัส TSIC-ID</th>
              <td style={{ width: "80%" }}>{data1.TSIC_ID}</td>
            </tr>
            <tr>
              <th style={{ width: "20%" }}>ชื่อนิติบุคคล</th>
              <td style={{ width: "80%" }}>{data1.JURISTIC_NAME}</td>
            </tr>
            <tr>
              <th style={{ width: "20%" }}>ที่ตั้งโรงงานควบคุม</th>
              <td style={{ width: "80%" }}>{data1.ADDRESS_NAME}</td>
            </tr>
          </tbody>
        </table>
        <table style={{ borderSpacing: "1px 1px" }}>
          <tbody>
            <tr>
              <th style={{ width: "20%" }}>วันที่ตรวจสอบ ตั้งแต่วันที่</th>
              <td style={{ width: "30%", textAlign: "center" }}>
                {tsDateToThaiDate(data2.START_D)}
              </td>
              <th style={{ width: "20%" }}>ถึงวันที่</th>
              <td style={{ width: "30%", textAlign: "center" }}>
                {tsDateToThaiDate(data2.START_D)}
              </td>
            </tr>
            {/* <tr>
                            <th style={{width:'20%'}}>ยืนยันการส่งผลการตรวจสอบทางอิเล็กทรอนิกส์แล้วเมื่อวันที่</th>
                            <td colspan="4" style={{width:'80%'}}>{tsDateToThaiDate(data2.CONFIRM_D)}</td>
                        </tr> */}
          </tbody>
        </table>
        <div>
          <div> ข้าพเจ้า 1 {data2.MD_1} </div>
          <div>ในฐานะ{data2.MD_STATUS}</div>
          <div>
            ขอรับรองว่า {data2.ORGANIZE_NAME}{" "}
            ผู้ได้รับใบอนุญาตตรวจสอบและรับรองการจัดการพลังงาน ประเภท{" "}
            {data2.PERMIT_ID} ใบอนุญาตเลขที่ {data2.PERMIT_ID}{" "}
          </div>
          <div>
            โดยบุคลากรดังต่อไปนี้ ได้ตรวจสอบการปฏิบัติงานจริง โรงงานควบคุม
            ระหว่างวันที่ {tsDateToThaiDate(data2.START_D)} ถึงวันที่{" "}
            {tsDateToThaiDate(data2.END_D)}
          </div>
        </div>
        {/* <span style={{display:'block', textAlign:'right'}}>
                    <ul className="myNavigation">
                        <li>
                            <button type="button"  className="myButton1" style={{verticalAlign:'top','height':'32px'}}
                            onClick={()=>{this.setState({visible2:true})}}>
                                <img src="images/iPencil.png"/>&nbsp;แก้ไข
                            </button>
                        </li>
                    </ul>
                </span> */}
      </div>
    );
  }

  Layout3() {
    let { data3, INTERVIEWER_ID } = this.state;
    return (
      <div>
        <h1>รายชื่อบุคลากร</h1>
        <table style={{ borderSpacing: "1px 1px" }}>
          <tbody>
            <tr>
              <th style={{ textAlign: "center" }}>ลำดับ</th>
              <th style={{ width: "55%", textAlign: "center" }}>ชื่อ-สกุล</th>
              <th style={{ width: "15%", textAlign: "center" }}>
                เลขประจำตัวประชาชน
              </th>
              <th style={{ width: "15%", textAlign: "center" }}>ตำแหน่ง</th>
              <th style={{ width: "15%", textAlign: "center" }}>
                วันที่ตรวจสอบ
              </th>
            </tr>
            {data3.map((d, i) => {
              return (
                <tr>
                  <td style={{ textAlign: "center" }}>{i + 1}</td>
                  <td>{d.EXPERT_NAME}</td>
                  <td style={{ textAlign: "center" }}>{d.PERSON_ID}</td>
                  <td>{d.POSITION}</td>
                  <td>{d.SIGN_D}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <span style={{ display: "block", textAlign: "right" }}>
          <ul className="myNavigation">
            <li>
              <button
                type="button"
                className="myButton1"
                style={{ verticalAlign: "top", height: "32px" }}
                onClick={() => {
                  this.getINTERVIEWER_ID();
                  this.setState({
                    visible3: true,
                    m3: JSON.parse(JSON.stringify(data3))
                  });
                }}
              >
                <img src="images/iPencil.png" />
                &nbsp;แก้ไข
              </button>
            </li>
          </ul>
        </span>
      </div>
    );
  }
  Layout4() {
    console.log("useruseruser", this.props.user);
    let CID = this.props.user?this.props.user.ID_CARD:"";
    let { data2, data4 } = this.state;
    let SIGN_1_D = tsDateToThaiDate(data4.SIGN_1_D);
    return <div>
        <br />
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ขอรับรองว่าข้อความข้างต้นถูกต้อง
          เป็นจริงทุกประการ
        </div>
        <br />
        <table className="MyStyle2">
          <tbody>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ลงชื่อ
                ........................................................................
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                {/* ลงชื่อ
                ........................................................................ */}
              <Button type="dashed" disabled={data4.PERMIT_NAME_ID !== CID}
                 style={{ margin: "0px 10px" }} onClick={() => {
                    this.setState({ visible5: true, modeLayout5Type: "1" });
                    setTimeout(() => {
                      this.getMD5();
                    }, 50);
                  }}>
                  ลงชื่อ
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.MD_1})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.PERMIT_NAME})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                (กรรมการผู้มีอำนาจ)
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                (ผู้รับใบอนุญาต)
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
            </tr>
            {/* 2 */}
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ลงชื่อ
                ........................................................................
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                {/* ลงชื่อ
                ........................................................................ */}
                <Button type="dashed" style={{ margin: "0px 10px" }} onClick={() => {
                    this.setState({ visible5: true, modeLayout5Type: "2" });
                    setTimeout(() => {
                      this.getMD5();
                    }, 50);
                  }} disabled={data4.AUDIT_1_ID !== CID}>
                  ลงชื่อ
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.MD_2})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.AUDIT_1})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                (กรรมการผู้มีอำนาจ)
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                (ผู้ชำนาญการ)
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
            </tr>
            {/* 3 */}
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ลงชื่อ
                ........................................................................
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                {/* ลงชื่อ
                ........................................................................ */}
                <Button type="dashed" style={{ margin: "0px 10px" }} disabled={data4.AUDIT_2_ID !== CID} onClick={() => {
                    this.setState({ visible5: true, modeLayout5Type: "3" });
                    setTimeout(() => {
                      this.getMD5();
                    }, 50);
                  }}>
                  ลงชื่อ
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.ENGY_1})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.AUDIT_2})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                (ผู้รับผิดชอบดานพลังงานอาวุโส)
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                (ผู้ช่วยชำนาญการ)
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
            </tr>
            {/* 4 */}
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ลงชื่อ
                ........................................................................
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                {/* ลงชื่อ
                ........................................................................ */}
                <Button type="dashed" style={{ margin: "0px 10px" }} onClick={() => {
                    this.setState({ visible5: true, modeLayout5Type: "4" });
                    setTimeout(() => {
                      this.getMD5();
                    }, 50);
                  }} disabled={data4.AUDIT_3_ID !== CID}>
                  ลงชื่อ
                </Button>
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.ENGY_2})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({data4.AUDIT_3})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                ({SIGN_1_D})
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>
                (ผู้รับผิดชอบด้านพลังงาน)
              </td>
              <td style={{ width: "33%", textAlign: "center" }}>
                (ผู้ช่วยชำนาญการ)
              </td>
            </tr>
            <tr>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
              <td style={{ width: "33%", textAlign: "center" }}>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <span style={{ display: "block", textAlign: "right" }}>
          <ul className="myNavigation">
            <li>
              <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
                  this.setState({ visible4: true, m4: { ...data2 } });
                }}>
                <img src="images/iPencil.png" />
                &nbsp;แก้ไข
              </button>
            </li>
          </ul>
        </span>
      </div>;
  }
  setCharAt(str, index, chr) {
    if (index > str.length - 1) return str;
    return str.substr(0, index) + chr + str.substr(index + 1);
  }
  setRand(str, chr, indexs, A) {
    var items = Array.from(str);
    var index = -1;
    while (!(index !== -1 && indexs.indexOf(index) === -1)) {
      index = Math.floor(Math.random() * items.length);
    }
    console.log(str[index], index, indexs);
    indexs.push(index);
    A.push({ char: chr, a: str[index], index: index });
    return { str: this.setCharAt(str, index, chr), indexs: indexs, A: A };
  }

  getDataValilda(_input1, _input2, _input3, _input4, _input5) {
    console.log("getDataValilda", _input1, _input2, _input3, _input4, _input5);
    return true;
  }
  getMD5() {
    let { data4, visible5, modeLayout5Type, visible5Submit } = this.state;
    console.log("this.getMD5();");
    let AUDIT = "";
    let AUDIT_ID = "";
    if (modeLayout5Type === "1") {
      AUDIT = data4.PERMIT_NAME;
      AUDIT_ID = data4.PERMIT_NAME_ID;
    } else if (modeLayout5Type === "2") {
      AUDIT = data4.AUDIT_1;
      AUDIT_ID = data4.AUDIT_1_ID;
    } else if (modeLayout5Type === "3") {
      AUDIT = data4.AUDIT_2;
      AUDIT_ID = data4.AUDIT_2_ID;
    } else if (modeLayout5Type === "4") {
      AUDIT = data4.AUDIT_3;
      AUDIT_ID = data4.AUDIT_3_ID;
    }
    let AUDIT_ID_Q = AUDIT_ID;
    let AUDIT_ID_A = "";
    let rand = ["A", "B", "C", "D", "E"];
    let _indexs = [];
    let _A = [];
    if (AUDIT_ID_Q && AUDIT_ID_Q.length > rand.length) {
      for (let i in rand) {
        let { str, indexs, A } = this.setRand(AUDIT_ID_Q, rand[i], _indexs, _A);
        AUDIT_ID_Q = str;
        _indexs = indexs;
        _A = A;
      }
    }
    _A.sort((a, b) => (a.index > b.index ? 1 : b.index > a.index ? -1 : 0));
    this.setState({
      _A: _A,
      AUDIT_ID_Q: AUDIT_ID_Q,
      AUDIT_ID: AUDIT_ID,
      AUDIT: AUDIT,
      visible5Submit: false,
      visible5SubmitPass: false,
      qr: ""
    });
  }
  MDLayout5() {
    let {
      qr,
      visible5SubmitPass,
      data4,
      visible5,
      modeLayout5Type,
      visible5Submit,
      AUDIT,
      AUDIT_ID,
      _A,
      AUDIT_ID_Q
    } = this.state;

    let index1 = "",
      index2 = "",
      index3 = "",
      index4 = "",
      index5 = "";
    for (const i in _A) {
      console.log(_A[i]);
      if (i === "0") {
        index1 = _A[i].char;
      } else if (i === "1") {
        index2 = _A[i].char;
      } else if (i === "2") {
        index3 = _A[i].char;
      } else if (i === "3") {
        index4 = _A[i].char;
      } else if (i === "4") {
        index5 = _A[i].char;
      }
    }
    console.log(AUDIT_ID);
    this.submit5 = false;
    return (
      <div>
        <Modal
          visible={visible5}
          title="ลงชื่อ"
          onOk={() => {}}
          onCancel={() => {
            this.setState({
              visible5: false,
              visible5Submit: false
            });
          }}
          footer={
            [
              <Button
                key="back"
                onClick={() => {
                  this.setState({
                    visible5: false,
                    visible5Submit: false
                  });
                }}
              >
                ปิด
              </Button>
            ]
          }
        >
          {visible5 ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ textAlign: "center" }}>
                <Col span={24}>
                  <h5
                    style={{
                      color: "#0d1a26",
                      fontFamily:
                        "Avenir,Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif",
                      fontVariant: "tabular-nums",
                      margin: "0",
                      fontWeight: 500,
                      clear: "both"
                    }}
                  >
                    ชื่อ: {AUDIT}
                  </h5>
                </Col>
              </div>
              <div>
                <Col span={24}>
                  <h5
                    style={{
                      color: "#0d1a26",
                      fontFamily:
                        "Avenir,Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif",
                      fontVariant: "tabular-nums",
                      margin: "0",
                      fontWeight: 500,
                      clear: "both"
                    }}
                  >
                    กรุณกรอกเลขบัตรประชาชนให้ถูกต้อง
                  </h5>
                </Col>
              </div>
              <div>
                <Col span={24}>
                  <h3
                    style={{
                      color: "#0d1a26",
                      fontFamily:
                        "Avenir,Chinese Quote,-apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif",
                      fontVariant: "tabular-nums",
                      margin: "0",
                      fontWeight: 500,
                      clear: "both"
                    }}
                  >
                    {visible5SubmitPass ? (
                      <div> {AUDIT_ID}</div>
                    ) : (
                      <div> {AUDIT_ID_Q}</div>
                    )}
                  </h3>
                </Col>
              </div>

              <div
                className={
                  visible5Submit && !visible5SubmitPass ? "has-error" : ""
                }
              >
                <InputGroup size="large">
                  <Col offset={5} span={3}>
                    <Input
                      defaultValue=""
                      maxLength={1}
                      placeholder={index1}
                      ref={input => {
                        this._input1 = input;
                      }}
                      onChange={e => {
                        if (this._input1.input.value) {
                          this._input2.input.value = "";
                          this._input2.focus();
                        }
                      }}
                      disabled={visible5SubmitPass}
                    />
                  </Col>
                  <Col span={3}>
                    <Input
                      defaultValue=""
                      maxLength={1}
                      placeholder={index2}
                      ref={input => {
                        this._input2 = input;
                      }}
                      onChange={e => {
                        if (this._input2.input.value) {
                          this._input3.input.value = "";
                          this._input3.focus();
                        }
                      }}
                      disabled={visible5SubmitPass}
                    />
                  </Col>
                  <Col span={3}>
                    <Input
                      defaultValue=""
                      maxLength={1}
                      placeholder={index3}
                      ref={input => {
                        this._input3 = input;
                      }}
                      onChange={e => {
                        if (this._input3.input.value) {
                          this._input4.input.value = "";
                          this._input4.focus();
                        }
                      }}
                      disabled={visible5SubmitPass}
                    />
                  </Col>
                  <Col span={3}>
                    <Input
                      defaultValue=""
                      maxLength={1}
                      placeholder={index4}
                      ref={input => {
                        this._input4 = input;
                      }}
                      onChange={e => {
                        if (this._input4.input.value) {
                          this._input5.input.value = "";
                          this._input5.focus();
                        }
                      }}
                      disabled={visible5SubmitPass}
                    />
                  </Col>
                  <Col span={3}>
                    <Input
                      defaultValue=""
                      maxLength={1}
                      placeholder={index5}
                      ref={input => {
                        this._input5 = input;
                      }}
                      disabled={visible5SubmitPass}
                      onChange={e => {
                        if (this._input5.input.value) {
                          this.setState({ visible5Submit: true });
                          let pass = 0;
                          for (const i in _A) {
                            console.log(_A[i]);
                            if (i === "0") {
                              if (this._input1.input.value === _A[i].a) {
                                pass = pass + 1;
                              }
                            } else if (i === "1") {
                              if (this._input2.input.value === _A[i].a) {
                                pass = pass + 1;
                              }
                            } else if (i === "2") {
                              if (this._input3.input.value === _A[i].a) {
                                pass = pass + 1;
                              }
                            } else if (i === "3") {
                              if (this._input4.input.value === _A[i].a) {
                                pass = pass + 1;
                              }
                            } else if (i === "4") {
                              if (this._input5.input.value === _A[i].a) {
                                pass = pass + 1;
                              }
                            }
                          }
                          if (pass === 5) {
                            let { latitude,longitude } = this.state;
                               let ll =  (latitude!==""&&longitude!=="")?
                               `,latitude${latitude},longitude=${longitude}`:''
                            this.setState({
                              visible5SubmitPass: true,
                              qr: `name=${AUDIT},idCard=${AUDIT_ID},datetime=${moment().format(
                                "YYYY-MM-DDTHH:mm:ss"
                              )}${ll}`
                            });
                                setTimeout(() => {
                                  let canvas = document.getElementById('canvas');
                                  if (canvas){
                                    let _canvas = canvas.childNodes[0];
                                    let img = _canvas.toDataURL()
                                    this.putDataLayout5(img);
                                  }
                                  // var imgData = canvas.toDataURL();
                                }, 50);

                          }
                          console.log(pass);
                        }
                      }}
                    />
                  </Col>
                </InputGroup>
              </div>
              <div style={{ margin: 10 }} id={"canvas"}>
                {visible5SubmitPass ? <QRCode value={qr} size={80}/> : null}
              </div>
            </div>
          ) : null}
        </Modal>
      </div>
    );
  }

  MDLayout2() {
    let { data1, data2, visible2 } = this.state;
    return (
      <div>
        <Modal
          visible={visible2}
          title="บันทึกข้อมูลระยะเวลาการตรวจสอบ"
          onOk={() => {}}
          onCancel={() => {
            this.setState({ visible2: false });
          }}
          footer={[
            <Button
              key="back"
              onClick={() => {
                this.setState({ visible2: false });
              }}
            >
              ปิด
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={false}
              onClick={() => {}}
            >
              บันทึกข้อมูล
            </Button>
          ]}
        />
      </div>
    );
  }

  MDLayout3() {
    let { data1, data2, visible3, m3, INTERVIEWER_ID } = this.state;

    return (
      <div>
        <Modal
          visible={visible3}
          width={1000}
          title="บันทึกทีมบุคลากรตรวจสอบ"
          onOk={() => {}}
          onCancel={() => {
            this.setState({ visible3: false });
          }}
          footer={[
            <Button
              key="back"
              onClick={() => {
                this.setState({ visible3: false });
              }}
            >
              ปิด
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={false}
              onClick={() => {
                this.setState({ visible3: false });
                //  this.putDataLayout3();
              }}
            >
              บันทึกข้อมูล
            </Button>
          ]}
        >
          <table style={{ borderSpacing: "1px 1px" }}>
            <tbody>
              <tr>
                {/* <th style={{textAlign:'center'}}>ลำดับ</th> */}
                {/* <th style={{width:'55%',textAlign:'center'}}>ชื่อ-สกุล</th> */}
                <th style={{ width: "25%", textAlign: "center" }}>
                  เลขประจำตัวประชาชน
                </th>
                <th style={{ width: "25%", textAlign: "center" }}>ตำแหน่ง</th>
                <th style={{ width: "25%", textAlign: "center" }}>
                  วันที่ตรวจสอบ
                </th>
                <th style={{ width: "25%", textAlign: "center" }} />
              </tr>
              {m3.map((d, i) => {
                return (
                  <tr>
                    {/* <td style={{textAlign:'center'}}>{i+1}</td> */}
                    {/* <td>{d.EXPERT_NAME}</td> */}
                    <td style={{ textAlign: "center" }}>
                      <Select
                        defaultValue=""
                        style={{ width: 350 }}
                        onChange={value => {
                          let { m3 } = this.state;
                          m3[i].PERSON_ID = value;
                          this.setState({ m3: m3 });
                        }}
                        value={d.PERSON_ID}
                      >
                        <Option value="">----กรุณาเลือก----</Option>
                        {INTERVIEWER_ID.map(r => {
                          return (
                            <Option value={r.PERSON_ID} selected="">
                              {r.PERSON_NAME}
                            </Option>
                          );
                        })}
                      </Select>
                      {/* {d.PERSON_ID} */}
                    </td>
                    <td>
                      {/* {d.POSITION} */}
                      <Select
                        defaultValue=""
                        style={{ width: 350 }}
                        onChange={value => {
                          let { m3 } = this.state;
                          m3[i].POSITION_C = value;
                          this.setState({ m3: m3 });
                        }}
                        value={d.POSITION_C}
                      >
                        <Option value="">----กรุณาเลือก----</Option>
                        {[].map(r => {
                          return (
                            <Option value={r.PERSON_ID} selected="">
                              {r.PERSON_NAME}
                            </Option>
                          );
                        })}
                      </Select>
                    </td>
                    <td>
                      {/* {d.SIGN_1_D} */}
                      <Datetimepicker
                        name={"SIGN_1_D_" + i}
                        value={d.SIGN_D}
                        onSelect={value => {
                          let { m3 } = this.state;
                          m3[i].SIGN_D = value;
                          this.setState({ m3: m3 });
                        }}
                      />
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <Button
                        key="back"
                        onClick={() => {
                          if (window.confirm("คุณต้องการลบ?")) {
                            let { m3 } = this.state;
                            m3 = m3.filter((r, ii) => ii != i);
                            this.setState({ m3: m3 });
                          }
                        }}
                      >
                        ลบ
                      </Button>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td style={{ textAlign: "center" }} />
                <td style={{ textAlign: "center" }} />
                <td style={{ textAlign: "center" }} />
                <td style={{ textAlign: "center" }}>
                  <Button
                    key="back"
                    onClick={() => {
                      let { m3 } = this.state;
                      m3.push({
                        PERSON_ID: "",
                        POSITION: "",
                        SIGN_1_D: ""
                      });
                      this.setState({ m3: m3 });
                    }}
                  >
                    เพิ่ม
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </Modal>
      </div>
    );
  }

  MDLayout4() {
    let { data1, data2, visible4, m4 } = this.state;
    return (
      <div>
        <Modal
          visible={visible4}
          title="บันทึกข้อมูลผู้ตรวจสอบรับรองการตรวจสอบฯ"
          onOk={() => {}}
          onCancel={() => {
            this.setState({ visible4: false });
          }}
          footer={[
            <Button
              key="back"
              onClick={() => {
                this.setState({ visible4: false });
              }}
            >
              ปิด
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={false}
              onClick={() => {
                this.putDataLayout4();
              }}
            >
              บันทึกข้อมูล
            </Button>
          ]}
        >
          <table>
            <tbody>
              <tr>
                <td>กรรมการผู้จัดการ (1)</td>
                <td>
                  {/* <input type="textbox" name="MD_1" class="" value="" size="40" maxlength="80"> */}
                  <input
                    type="textbox"
                    value={m4.MD_1}
                    size="40"
                    maxlength="80"
                    onChange={e => {
                      // let { m4 } = this.state;
                      m4.MD_1 = e.target.value;
                      this.setState({ m4: m4 });
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>กรรมการผู้จัดการ (2)</td>
                <td>
                  {/* <input type="textbox" name="MD_2" class="" value="" size="40" maxlength="80"> */}
                  <input
                    type="textbox"
                    value={m4.MD_2}
                    size="40"
                    maxlength="80"
                    onChange={e => {
                      // let { m4 } = this.state;
                      m4.MD_2 = e.target.value;
                      this.setState({ m4: m4 });
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td>สถานะกรรมการลงนาม</td>
                <td>
                  <RadioGroup
                    onChange={e => {
                      console.log(e);
                      m4.MD_STATUS = e.target.value;
                      this.setState({ m4: m4 });
                    }}
                    value={m4.MD_STATUS}
                  >
                    <Radio value={"1"}>ผู้มีอำนาจผูกพันนิติบุคคล</Radio>
                    <Radio value={"2"}>ผู้รับมอบอำนาจ</Radio>
                  </RadioGroup>

                  {/* <input type="radio" name="MD_STATUS" class="" value="1"> */}

                  {/* <input type="radio" name="MD_STATUS" class="" value="2"> */}
                </td>
              </tr>
              <tr>
                <td colspan="2" align="right">
                  &nbsp;
                </td>
              </tr>
            </tbody>
          </table>
        </Modal>
      </div>
    );
  }

  render() {
    let { modeLayout1, modeLayout2, modeLayout3, modeLayout4 } = this.state;

    return (
      <div>
        <div className="myForm-2" style={{ minHeight: "530px" }}>
          {this.MDLayout2()}
          {this.MDLayout3()}
          {this.MDLayout4()}
          {this.MDLayout5()}
          {modeLayout1 ? this.Layout1() : null}
          {modeLayout3 ? this.Layout3() : null}
          {modeLayout4 ? this.Layout4() : null}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { token: state.default.token, user: state.default.user };
}

export default connect(mapStateToProps)(Xpage6ef04dc17);
// export default Xpage6ef04dc17;



// WEBPACK FOOTER //
// ./src/view/main/xpage6/ef04dc17.js